<template>
  <tr>
    <td class="noStyle"></td>
    <td colspan="8" class="options">
      <div class="options__split" style="display: block;">

        <div class="optionsPanel__content optionsPanel__content" style="display: flex;text-align: center;width: 100%;" v-show="quote.uses_franking_machine">
            <span style="margin: 0 auto; color: #0a70e3; margin-bottom:20px; font-weight:700;font-size: 1.8rem;text-transform: none;" v-show="current_costs.printer.id !== 1">
                Total current cost of ownership:&nbsp;<span class="cost" v-html="makeNumberWithPound(current_costs.total_cost_per_annum.toFixed(2))"></span>&nbsp;(<span v-html="makeNumberWithPound((current_costs.total_cost_per_annum / 4).toFixed(2))" style="font-weight: 600;font-size: 1.8rem"></span>&nbsp;per quarter)<span class="cost">^</span>
            </span>
        </div>

        <span style="margin: 0 auto; color: #b50a78; margin-bottom:20px; font-weight:700;font-size: 1.8rem;text-transform: none;">
              Based on your requirements, we can provide the following options:
          </span>

        <br><br>

        <div style="width: 100%;">

          <div class="proposed-quote-details-table">
            <div class="optionsPanel optionsPanel--withSide" v-for="option, index in options" style="flex: 1;margin:5px;border: 1px solid #ccc;border-radius:16px;padding:15px">
              <div style="flex-grow: 1;height:65%">
                <div style="display: flex; flex-direction: row">
                  <div style="position:absolute;">
                    <img :src="`/static/styles/mailkit/img/Place${index+1}.png`" style="padding: 0px;width:50px;height:50px"/>
                  </div>
                  <div style="display:flex;align-items: center;margin: 0 auto;position: relative;">
                    <h5 style="margin: 0 auto;color:#0a70e3;font-weight:700;font-size:1.8rem;padding:0 25px"> {{ option.years ? option.years + ' year lease option' : 'Purchase option' }} </h5>
                  </div>
                </div>


                <div class="optionsPanel__prices" style="font-weight:700">
                  <div v-if="quote.uses_franking_machine">
                    <div v-if="option.years">
                      <h5 class="blue" style="font-weight:700">Quarterly investment <span v-html="makeNumberWithPound(option.total_investment)" style="font-weight:700;font-size:1.4rem;"></span><span style="font-weight:700;font-size:1.4rem;" v-if="parseFloat(option.savings_over_term) < 0">*</span><span style="font-weight:700;font-size:1.4rem;" v-if="parseFloat(option.savings_over_term) >= 0">^^</span></h5>

                      <h5 class="red" style="font-weight:700">
                        <span>
                          <span v-if="option.effective_annual_saving > 0" style="font-weight:700">Annual saving: <span v-html="makeNumberWithPound(option.effective_annual_saving)" style="font-weight:700"></span>**<br></span>
                          <span v-if="option.savings_over_term > 0" style="font-weight:700">Total savings over term: <span v-html="makeNumberWithPound(option.savings_over_term)" style="font-weight:700"></span>**</span>
                        </span>
                      </h5>
                    </div>

                    <div v-else>
                      <h5 class="blue" style="font-weight:700">First year cost <span v-html="makeNumberWithPound(option.total_investment)" style="font-weight:700;font-size:1.4rem;"></span>*</h5>
                      <h5 class="blue" style="font-weight:700">Year 2 service cost <span v-html="makeNumberWithPound(option.total_service_cost)" style="font-weight:700;font-size:1.4rem;"></span></h5>

                      <h5 class="red" style="font-weight:700">
                        <span>
                          <span v-if="option.savings_over_term > 0" style="font-weight:700">Savings over 5 years: <span v-html="makeNumberWithPound(option.savings_over_term)" style="font-weight:700"></span>**</span>
                        </span>
                      </h5>
                    </div>
                  </div>

                  <div v-if="!quote.uses_franking_machine">
                    <div v-if="option.years">
                      <h5 class="blue" style="font-weight:700">Quarterly investment <span v-html="makeNumberWithPound(option.total_investment)" style="font-weight:700;font-size:1.4rem;"></span>*</h5>

                      <h5 class="red" style="font-weight:700">
                        <span>
                          <span v-if="option.annual_postage_savings > 0" style="font-weight:700">Annual postage savings: <span v-html="makeNumberWithPound(option.annual_postage_savings)" style="font-weight:700"></span>**<br></span>
                          <span v-if="option.postage_savings_over_term > 0" style="font-weight:700">Total postage savings over term: <span v-html="makeNumberWithPound(option.postage_savings_over_term)" style="font-weight:700"></span>**</span>
                        </span>
                      </h5>
                    </div>

                    <div v-else>
                      <h5 class="blue" style="font-weight:700">First year cost <span v-html="makeNumberWithPound(option.total_investment)" style="font-weight:700;font-size:1.4rem;"></span>*</h5>
                      <h5 class="blue" style="font-weight:700">Year 2 cost <span v-html="makeNumberWithPound(option.total_service_cost)" style="font-weight:700;font-size:1.4rem;"></span></h5>

                      <h5 class="red" style="font-weight:700">
                        <span>
                          <span v-if="option.postage_savings_over_term > 0" style="font-weight:700">Postage savings over 5 years: <span v-html="makeNumberWithPound(option.postage_savings_over_term)" style="font-weight:700"></span>**</span>
                        </span>
                      </h5>
                    </div>
                  </div>

  <!--                <h5 class="red" style="font-weight:700">-->
  <!--                  <span>-->
  <!--                    <span v-if="(option.switch_and_save > 0 && !option.years)" style="font-weight:700">Year 1 saving:</span>-->
  <!--                    <span v-if="(option.switch_and_save <= 0 && !option.years)" style="font-weight:700">Year 1 investment:</span>-->
  <!--                    <span v-if="option.switch_and_save > 0 && !option.years" v-html="makeNumberWithPound(option.switch_and_save) + '**'" style="font-weight:700"></span>-->
  <!--                    <span v-if="option.switch_and_save <= 0 && !option.years" v-html="makeNumberWithPound(Math.abs(option.switch_and_save)) + '**'" style="font-weight:700"></span>-->

  <!--                    <span v-if="option.switch_and_save > 0 && option.years" style="font-weight:700">Annual saving:</span>-->
  <!--                    <span v-if="option.switch_and_save <= 0 && option.years" style="font-weight:700">Annual investment:</span>-->
  <!--                    <span v-if="option.switch_and_save > 0 && option.years" v-html="makeNumberWithPound(option.effective_annual_saving) + '**'" style="font-weight:700"></span>-->
  <!--                    <span v-if="option.switch_and_save <= 0 && option.years" v-html="makeNumberWithPound(Math.abs(option.effective_annual_saving)) + '**'" style="font-weight:700"></span>-->
  <!--                  </span>-->
  <!--                </h5>-->

  <!--                <h5 class="red">-->
  <!--                  <span v-if="option.savings_over_term > 0" style="font-weight:700">Switch and save:</span>-->
  <!--                  <span v-if="option.savings_over_term <= 0" style="font-weight:700">Total effective cost:</span>-->
  <!--                  <span v-if="option.savings_over_term > 0" v-html="makeNumberWithPound(option.savings_over_term) + '**'" style="font-weight:700"></span>-->
  <!--                  <span v-if="option.savings_over_term <= 0" v-html="makeNumberWithPound(Math.abs(option.savings_over_term)) + '**'" style="font-weight:700"></span>-->
  <!--                  <span v-if="option.years"><br>Calculated based on the total lease term</span>-->
  <!--&lt;!&ndash;                  <span v-if="!option.years"><br>Calculated based on a 5 year term</span>&ndash;&gt;-->
  <!--                </h5>-->
                </div>
              </div>
              <a @click="progressWithOrder(option.years)" class="btn btn-gradient" style="cursor:pointer;">Proceed</a>
            </div>
          </div>

          <!------
          <div class="optionsPanel optionsPanel--withSide" v-for="option, index in options" style="flex: 30%;margin:5px;border: none;">
            <table style="margin-top:0;">
              <tr>
                <td>
                  <h5> {{ option.years ? option.years + ' YEAR LEASE INVESTMENT OPTION' : 'PURCHASE INVESTMENT OPTION' }} </h5>
                  <div class="optionsPanel__prices">
                    <h5 class="red">TOTAL INVESTMENT: <span v-html="makeNumberWithPound(option.total_investment)"></span> {{ option.years ? 'PER QUARTER' : 'YEAR ONE' }}</h5>
                    <h5 class="blue">
                      <span v-if="option.switch_and_save >= 0">
                        SWITCH & SAVE: <span v-html="makeNumberWithPound(option.switch_and_save)"></span> {{ option.years ? 'PER QUARTER' : 'YEAR ONE' }}
                      </span>
                      <span v-if="option.switch_and_save < 0">
                        EFFECTIVE COST: <span v-html="makeNumberWithPound(Math.abs(option.switch_and_save))"></span> {{ option.years ? 'PER QUARTER' : 'YEAR ONE' }}
                      </span>
                    </h5>
                    <h5 class="red">

                      <span v-if="option.savings_over_term > 0">
                        SAVING:
                      </span>
                      <span v-else>
                        Effective Cost:
                      </span>
                      <span v-html="makeNumberWithPound(Math.abs(option.savings_over_term))"></span>
                      <span v-if="!option.years">
                        <span v-if="option.savings_over_term > 0">Per Annum Based on 5 year investment period</span>
                        <span v-else>Per Annum Based on 5 year investment period</span>
                      </span>
                      <span v-else>
                        Per Annum
                      </span>
                    </h5>
                  </div>
                  <a @click="progressWithOrder(option.years)" class="btn btn-gradient" style="cursor:pointer;">Proceed</a>
                </td>
              </tr>
            </table>
          </div>
          ------>

        </div>

        <div style="text-align: center;color: black;padding: 10px 0px;text-transform: none">
          <b class="red" style="font-weight:bold;font-size: 1.4rem;" v-if="quote.uses_franking_machine">
            ^ Includes rental, service, invoice fees, insurance fees, recrediting fees and consumables where applicable<br>
          </b>

          <b class="red" style="font-weight:bold;font-size: 1.4rem;" v-if="!quote.uses_franking_machine && postageSavingsOverTermPositive >= 0">
            ** Based on the daily volume of letters provided. Assumes all mail processed is letter format (0-100g).<br>
          </b>

          <template v-if="quote.uses_franking_machine && options[0].savings_over_term > 0">
            <b class="blue" style="font-weight:bold;font-size: 1.4rem;">^^ Includes, rental/purchase, service, consumables and recredit fee costs<br></b>
          </template>

          <template v-if="(quote.uses_franking_machine && savingsOverTermNegative > 0) || !quote.uses_franking_machine">
            <b class="blue" style="font-weight:bold;font-size: 1.4rem;">* Includes both rental/purchase and service costs.<br></b>
          </template>

          <b class="red" style="font-weight:bold;font-size: 1.4rem;" v-if="quote.uses_franking_machine && savingsOverTermPositive > 0">
            ** Includes anticipated savings on ink, labels, postage and machine rental/service costs<br>
          </b>
          <br>
          <b class="blue" style="font-weight:bold;font-size: 1.4rem;" v-if="quote.uses_franking_machine">Please note: Additional costs may apply for delivery, installation and administration. Consumable spend includes estimated ink, labels and recrediting charges</b>
          <b class="blue" style="font-weight:bold;font-size: 1.4rem;" v-if="!quote.uses_franking_machine">Please note: Additional costs may apply for delivery, installation and administration.</b>
          <!--All costs and savings have been calculated using the full costs associated with your existing arrangement. This includes any ink and label costs, postage top up fees, invoicing and insurance fees you currently pay.<br><br>-->
          <!--Please note: An additional one off set up and delivery fee of £120 applies to all orders-->

        </div>

        <div style="background: linear-gradient(45deg,#0a70e3,#f81e8c);color: #fff;font-size: 44px;padding:30px">
          Free ink and labels up to the value of £100<br>with every qualifying order*<br><span style="color: #fff;display: block;margin-top: 20px;font-size: 20px;">*Terms and conditions may apply. Click <a href="https://themailingexpert.com/terms-and-conditions/#promotion-terms-conditions" style="color:#fff;font-size:inherit">here</a></span>
        </div>

        <div style="display: flex; width: 100%;" class="advert-banner-table">
          <div style="flex: 50%;display:flex;">
            <div class="optionsPanel" style="width: 100%;display: flex;align-items: center;justify-content: center;">
              <div class="optionsPanel__image">
                <img :src="manufacturerImage(model.manufacturer_id)" class="manufacturer_image" :class="{'width-250' : model.manufacturer_id === 5}"/>
              </div>
            </div>
          </div>
          <div style="flex: 50%;">
            <div class="optionsPanel" v-if="videoEmbed" style="border-left: none;">
              <div class="optionsPanel__content optionsPanel__content--noPadding">
                <h5>{{ model.model }} DEMO VIDEO</h5>
                <div v-html="videoEmbed"></div>

              </div>
            </div>
          </div>
        </div>

        <div style="width: 100%; padding-left: 0px;">
          <table class="featureTable">
            <thead>
            <th>
              Feature
            </th>
            <th>
              Specification
            </th>
            <th>
              Info and upgrade options
            </th>
            </thead>
            <tbody>
            <tr class="bg-grey-light">
              <td>
                Printing capabilities
              </td>
              <td>
                {{ model.printing_capabilities }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="PRINTING CAPABILITIES">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Programmable jobs
              </td>
              <td>
                {{ model.programmable_jobs }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="PROGRAMMABLE JOBS">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Ink yield
              </td>
              <td>
                {{ model.ink_yield }} impressions per ink cartridge
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="INK YIELD">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Cost per impression
              </td>
              <td>
                <span v-html="makeNumberWithPound(model.cost_per_impression, 4)"></span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="COST PER IMPRESSION">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Logo return address capacity
              </td>
              <td>
                {{ model.return_address_capacity }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="LOGO RETURN ADDRESS CAPACITY">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Interface type
              </td>
              <td>
                {{ model.interface_type }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="INTERFACE TYPE">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Mail feeder
              </td>
              <td>
                {{ model.mail_feeder }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="MAIL FEEDER">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Label dispenser
              </td>
              <td>
                {{ model.label_dispenser }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="LABEL DISPENSER">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Web based reporting
              </td>
              <td>
                <img src="./../../../static/styles/mailkit/img/tick.png"
                     v-if="model.web_based_reporting === 'yes'"/>
                <img src="./../../../static/styles/mailkit/img/cross.png" v-else/>

              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="WEB BASED REPORTING">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Dimension
              </td>
              <td>
                {{ model.dimensions }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="DIMENSIONS">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Mail mark compliant
              </td>
              <td>
                <img src="./../../../static/styles/mailkit/img/tick.png"
                     v-if="model.mail_mark_compliant === 'yes'"/>
                <img src="./../../../static/styles/mailkit/img/cross.png" v-else/>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="MAIL MARK COMPLIANT">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Installation and training
              </td>
              <td>
                <img src="./../../../static/styles/mailkit/img/tick.png"
                     v-if="model.engineer_installation_training === 'Included' || additionalOptions.engineer_installation_training === 'add'"/>
                <img src="./../../../static/styles/mailkit/img/cross.png"
                     v-if="additionalOptions.engineer_installation_training !== 'add' && (additionalOptions.engineer_installation_training === false || model.engineer_installation_training === null || model.engineer_installation_training === 'Not Included (Available at additional cost)')"/>
                <span v-if="additionalOptions.engineer_installation_training === null && model.engineer_installation_training === 'Not Included (Available at additional cost)'">
                  <br>
                  Available at additional cost
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="INSTALLATION AND TRAINING">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Scale capacity
              </td>
              <td>
                {{ formatScale(model, additionalOptions) }} KG
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="SCALE CAPACITY">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Custom Logo/Return Address Included with New Machine
              </td>
              <td>
                <span v-if="additionalOptions.logo_and_return_address === 'add' || (model.return_address_included_with_machine === 'Included' && additionalOptions.logo_and_return_address === null)">
                  <img src="./../../../static/styles/mailkit/img/tick.png">
                </span>
                <span v-else>
                  <img src="./../../../static/styles/mailkit/img/cross.png"/>
                  <br>
                  <span v-if="additionalOptions.logo_and_return_address === null">Available at additional cost</span>
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;"
                     data-ft="CUSTOM LOGO/RETURN ADDRESS INCLUDED WITH NEW MACHINE">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Business mail advanced
              </td>
              <td>
                <span v-if="additionalOptions.business_mail_advanced === 'add'">
                  <img src="./../../../static/styles/mailkit/img/tick.png">
                </span>
                <span v-if="(model.business_mail_advanced && !model.business_mail_advanced.includes('included')) || additionalOptions.business_mail_advanced === false">
                  <img src="./../../../static/styles/mailkit/img/cross.png"/>
                </span>
                <span v-if="(model.business_mail_advanced && model.business_mail_advanced.includes('included')) && additionalOptions.business_mail_advanced === null">
                  <img src="./../../../static/styles/mailkit/img/cross.png"/>
                  <br>
                  <span>Available at additional cost</span>
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="BUSINESS MAIL ADVANCED">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Connectivity kit options
              </td>
              <td>
                <span v-if="additionalOptions.connectivity === null">
                  {{ model.connectivity }}
                </span>
                <span style="text-transform: uppercase" v-if="additionalOptions.connectivity !== null">
                  {{ additionalOptions.connectivity }}
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="CONNECTIVITY KIT OPTIONS">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Inbound courier parcel tracing
              </td>
              <td>
                <img src="./../../../static/styles/mailkit/img/tick.png"
                     v-if="model.integrated_internal_mail_tracking_app && model.integrated_internal_mail_tracking_app.includes('Included') && (additionalOptions.inbound_courier_parcel_tracking_cost === null || additionalOptions.inbound_courier_parcel_tracking_cost === 'add')"/>
                <img src="./../../../static/styles/mailkit/img/cross.png" v-else/>
                <br>
                {{ model.integrated_internal_mail_tracking_app }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="INBOUND COURIER PARCEL TRACING">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Outbound shipping application
              </td>
              <td>
                <span v-if="additionalOptions.outbound_shipping_application === null">
                  {{ model.shipping_application }}
                  <span v-if="model.shipping_application === 'Yes Single User Included (Optional Kit available includes 30kg Scale and Shipping Label Printer)'">
                   Available at additional cost
                  </span>
                </span>
                <span v-else>
                  <span v-if="additionalOptions.outbound_shipping_application === 'add'">
                    <img src="./../../../static/styles/mailkit/img/tick.png"/>
                  </span>
                  <span v-if="additionalOptions.outbound_shipping_application === false">
                    <img src="./../../../static/styles/mailkit/img/cross.png"/>
                  </span>
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="OUTBOUND SHIPPING APPLICATION">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Departmental accounting
              </td>
              <td>
                {{ getModelDepAccounting(model) }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="DEPARTMENTAL ACCOUNTING">
                </div>
              </td>
            </tr>
            <tr class="border-t-3">
              <td>
                Differential weighting
              </td>
              <td>
                <img src="./../../../static/styles/mailkit/img/tick.png" v-if="additionalOptions.differential_weighting === 'add'"/>
                <img src="./../../../static/styles/mailkit/img/cross.png" v-if="!model.differential_weighting || model.differential_weighting === 'No' || additionalOptions.differential_weighting === false"/>
                <span v-if="(model.differential_weighting === 'Yes' || model.differential_weighting === 'Optional') && additionalOptions.differential_weighting === null">
                  Available at additional cost
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="DIFFERENTIAL WEIGHING">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light border-t-3">
              <td>
                Service / maintenance offering
              </td>
              <td>
                <span v-if="service_upgrade === 'standard'">
                  {{ model.service_name }}
                </span>
                <span v-if="service_upgrade === 'enhanced'">
                  <span v-if="model.manufacturer_id === 4">swapit+</span>
                  <span v-if="model.manufacturer_id === 3">total care</span>
                </span>
                <span v-if="service_upgrade === null">
                  {{ model.service_name }}
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="SERVICE / MAINTENANCE OFFERING">
                </div>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr class="bg-grey-light">
              <td>
                First step
              </td>
              <td>
                {{ model.first_step }}
              </td>
              <td>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="FIRST STEP">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td>
                Second step
              </td>
              <td>
                {{ model.second_step }}
              </td>
              <td>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="SECOND STEP">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td>
                {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? 'ENHANCED' : null }} Third step
              </td>
              <td>
                {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? model.enhanced_third_step : model.third_step }}
              </td>
              <td>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="THIRD STEP">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td>
                {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? 'ENHANCED' : null }} Targeted service level
              </td>
              <td>
                {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? model.sla_enhanced : model.sla_standard }}
              </td>
              <td>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="TARGETED SERVICE LEVEL">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td>
                All parts
              </td>
              <td>
                <img src="./../../../static/styles/mailkit/img/cross.png"
                     v-if="model.all_parts === null"/>
                <span v-else>
                   <img src="./../../../static/styles/mailkit/img/tick.png"/> Yes
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="ALL PARTS">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td>
                All labour
              </td>
              <td>
                <img src="./../../../static/styles/mailkit/img/cross.png"
                     v-if="model.all_labour === null"/>
                <span v-else>
                   <img src="./../../../static/styles/mailkit/img/tick.png"/> Yes
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="ALL LABOUR">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td>
                Wear & tear
              </td>
              <td>
                <img src="./../../../static/styles/mailkit/img/cross.png"
                     v-if="model.wear_and_tear === null"/>
                <span v-else>
                   <img src="./../../../static/styles/mailkit/img/tick.png"/> Yes - Excluding Consumable Parts
                </span>

              </td>
              <td>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="WEAR & TEAR">
                </div>
              </td>
            </tr>
            <tr class="bg-grey-light">
              <td>
                Royal mail rate updates
              </td>
              <td>
                {{ model.tariff_rate_updates_included_per_annum }} Per annum
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="ROYAL MAIL RATE UPDATES">
                </div>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr class="border-t-3">
              <td>
                Postage account type
              </td>
              <td>
                <span v-if="additionalOptions.postage_payment" style="text-transform: uppercase">
                  {{ additionalOptions.postage_payment }}
                </span>
                <!--<span v-else>-->
                <!--{{ model.manufacturer_id == 3 || model.manufacturer_id == 2 ? 'Arvanced or arrears' : 'ADVANCED' }}-->
                <!--</span>-->
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE">
                  <article v-if="additionalOptions.postage_payment === 'arrears'">
                    <header>
                      <strong>PAYMENT IN ARREARS:</strong>
                    </header>
                    <p>This service is only available through Pitney Bowes and Quadient (Neopost) at this time. This service
                      allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather
                      than an invoice for every postage top up/refill a monthly statement covering all transactions
                      during that monthly billing period is instead sent. This service typically carries higher
                      recrediting fees but reduces the number of invoices to one consolidated monthly statement and
                      means your business doesn't have funds tied up and sitting in a holding account. Pitney Bowes
                      payment in arrears service is called Purchase Power. Quadient (Neopost) is called Neofunds. </p>
                  </article>

                  <article v-if="additionalOptions.postage_payment === 'advanced'">
                    <header>
                      <strong>PAYMENT IN ADVANCED:</strong>
                    </header>
                    <p>The payment in advanced services are available from all manufacturers and require your business
                      to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds
                      will be drawn down from your account. For each top up/refill transaction your business will be
                      invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this
                      invoice your holding/deposit account is replenished to the agreed balance ensuring you have
                      suitable funds available for when you next need to top up.</p>
                  </article>
                </div>
              </td>
            </tr>

            <tr style="background: white;border-top:0" v-if="additionalOptions.postage_payment === 'advanced'">
              <td>
                Free resets
              </td>
              <td>
                <span style="text-transform: uppercase">
                  <!-- Commented out by Duncan's request from 16.08.2019 at 7:00PM GMT+2 {{ model.postage_credit_account_free_resets || 0 }} -->
                  {{ model.postage_deposit_account || 0 }}
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr v-if="additionalOptions.postage_payment === 'advanced'">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE"></div>
              </td>
            </tr>


            <tr style="background: white;border-top:0" v-if="additionalOptions.postage_payment === 'advanced'">
              <td>
                Cost per additional reset
              </td>
              <td>
                <span style="text-transform: uppercase" v-html="makeNumberWithPound(model.postage_deposit_account_cost_per_resets || 0)"></span>
              </td>
              <td>
              </td>
            </tr>
            <tr v-if="additionalOptions.postage_payment === 'advanced'">
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE"></div>
              </td>
            </tr>


              <tr style="background: #f4f4f4;border-top:0" v-if="additionalOptions.postage_payment === 'arrears'">
                <td>
                    Your Monthly Top Up Cost*
                </td>
                <td>
                    &pound;{{ (new_costs.postage_recredit_costs / 12).toFixed(2) || 0 }}
                </td>
                <td>
                    *Based on monthly postage spend
                </td>
            </tr>

            <tr v-if="additionalOptions.postage_payment === 'arrears'">
                <td colspan="3" class="nopadding">
                    <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE"></div>
                </td>
            </tr>

            <tr style="background: #f4f4f4;border-top:0" v-if="additionalOptions.postage_payment === 'arrears'">
                <td>
                    Top up value range
                </td>
                <td>
                    Cost per top up
                </td>
                <td></td>
            </tr>

            <tr v-if="additionalOptions.postage_payment === 'arrears'">
                <td colspan="3" class="nopadding">
                    <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE"></div>
                </td>
            </tr>
        </tbody>

        <tbody v-if="additionalOptions.postage_payment === 'arrears' && model.manufacturer.name === 'Quadient (Neopost)'">
            <tr>
                <td>&pound;0 - &pound;800</td>
                <td>&pound;{{model.monthly_top_up_option_1_unlimited_transactions_monthly_fee}}</td>
                <td></td>
            </tr>

            <tr>
              <td>&pound;801 - &pound;2,000</td>
              <td>&pound;{{model.monthly_top_up_option_2_unlimited_transactions_monthly_fee}}</td>
              <td></td>
            </tr>

            <tr>
              <td>&pound;2001 - &pound;4,000</td>
              <td>&pound;{{model.monthly_top_up_option_3_unlimited_transactions_monthly_fee}}</td>
              <td></td>
            </tr>

            <tr>
              <td>&pound;4001 - &pound;10,000</td>
              <td>&pound;{{model.monthly_top_up_option_4_unlimited_transactions_monthly_fee}}</td>
              <td></td>
            </tr>

            <tr v-if="quote.postage_spend_custom > 10000">
              <td>&pound;10,001+</td>
              <td>{{model.totalcare_transaction_fees_option_5}}%</td>
              <td></td>
            </tr>
        </tbody>

        <tbody v-if="additionalOptions.postage_payment === 'arrears' && model.manufacturer.name === 'PITNEY BOWES'">
            <tr>
                <td>&pound;0 - &pound;100</td>
                <td>&pound;{{model.monthly_top_up_option_1_transaction_fee}}</td>
                <td></td>
            </tr>

            <tr>
                <td>&pound;101 - &pound;300</td>
                <td>&pound;{{model.monthly_top_up_option_2_transaction_fee}}</td>
                <td></td>
            </tr>

            <tr>
                <td>&pound;301 - &pound;1,300</td>
                <td>&pound;{{model.monthly_top_up_option_3_transaction_fee}}</td>
                <td></td>
            </tr>

            <tr>
                <td>&pound;1,300+</td>
                <td>{{model.monthly_top_up_option_4_transaction_fee}}%</td>
                <td></td>
            </tr>
        </tbody>
          </table>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  import {mapMutations} from "vuex";

  export default {
    props: [
      'current_costs', 'new_costs', 'model', 'quote', 'service_upgrade', 'quote_confirmation', 'additionalOptions',
    ],
    created() {
      this.videoEmbed = false
      let options = [];
      options.push({
        years: this.quote.lease_option_1,
        total_investment: this.getTotalEffectiveCostValue(this.quote.lease_option_1 - 1),
        switch_and_save: this.getSwitchAndSaveValue(this.quote.lease_option_1 - 1),
        savings_over_term: this.getSavingOverTermValue(this.quote.lease_option_1 - 1),
        annual_postage_savings: this.getAnnualPostageSavingsValue(this.quote.lease_option_1 - 1),
        postage_savings_over_term: this.getPostageSavingOverTermValue(this.quote.lease_option_1 - 1),
        effective_annual_saving: this.getEffectiveAnnualSaving(this.quote.lease_option_1 - 1),
      })
      options.push({
        years: this.quote.lease_option_2,
        total_investment: this.getTotalEffectiveCostValue(this.quote.lease_option_2 - 1),
        switch_and_save: this.getSwitchAndSaveValue(this.quote.lease_option_2 - 1),
        savings_over_term: this.getSavingOverTermValue(this.quote.lease_option_2 - 1),
        annual_postage_savings: this.getAnnualPostageSavingsValue(this.quote.lease_option_2 - 1),
        postage_savings_over_term: this.getPostageSavingOverTermValue(this.quote.lease_option_2- 1),
        effective_annual_saving: this.getEffectiveAnnualSaving(this.quote.lease_option_2 - 1),
      })
      if (this.quote_confirmation) {
        options.push({
          years: false,
          total_investment: this.getTotalEffectiveCostValue(),
          switch_and_save: this.getSwitchAndSaveValue(),
          savings_over_term: this.getSavingOverTermValue(),
          annual_postage_savings: this.getAnnualPostageSavingsValue(),
          postage_savings_over_term: this.getPostageSavingOverTermValue(),
          effective_annual_saving: this.getEffectiveAnnualSaving(),
          total_service_cost: this.getTotalServiceCost()
        })
      }

      if (this.quote.uses_franking_machine) {
        this.options = options.sort(function (a, b) {
          return b.savings_over_term - a.savings_over_term
        })
      } else {
        this.options = options.sort(function (a, b) {
          return a.total_investment - b.total_investment
        })
      }
    },

    mounted() {
      let app = this;
      this.getYoutubeEmbed(this.model.video_url);

      $('.infoToggle').off().click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        let $el = $(this).parent().parent().next().find('.infoContent');
        var feature = $el.attr('data-ft');
        if (app.getMoreInfo(feature)) {
          $el.html(app.getMoreInfo(feature));
        }

       if(!($el.hasClass('active')))
          $el.addClass('active').slideDown(300);
        else
          $el.removeClass('active').slideUp(300)

        return false;
      });
    },

    data() {
      return {
        options: false,
        videoEmbed: null,
      }
    },

    computed: {
      savingsOverTermPositive() {
        let count = 0
        this.options.forEach((option) => {
          if (option.savings_over_term > 0) {
            count++
          }
        })

        return count
      },

      savingsOverTermNegative() {
        let count = 0
        this.options.forEach((option) => {
          if (option.savings_over_term < 0) {
            count++
          }
        })

        return count
      },

      postageSavingsOverTermPositive() {
        let count = 0
        this.options.forEach((option) => {
          if (option.postage_savings_over_term > 0) {
            count++
          }
        })

        return count
      },
    },

    methods: {
      ...mapMutations('QuoteOptions', ['setOption']),

      getMoreInfo(feature) {
        var text = ''
        feature = feature.toUpperCase()

        switch (feature) {
          case 'BUSINESS MAIL ADVANCED' :
            text = 'Business Mail Advanced is a discounted mail tariff for businesses sending over 250 Letter format (DL/C5) items in any single mailing, discounts are based on items with clean addresses i.e. allowing Royal Mail to read and automatically sort/process mail without manual intervention and in doing so they pass on savings for this automation.'
            break

          case 'PRINTING CAPABILITIES':
            text = 'The vast majority of franking machines allow only for the ability to print in blue franking ink. Pitney Bowes offer a range of machines starting at automatic feeding which allow the option of mono capable or full colour capable printing, these then allow the business the option to print across the full width of the envelope in mono or colour inline with the indicia.'
            break

          case 'PROGRAMMABLE JOBS':
            text = 'The Programmable jobs function allows you to save the key jobs as presets into the franking machine. This allows for quick selection of the most popular mailing types to speed up the processing of mail. E.g. A job could be set as 1st class, large letter with all items processed to be recorded against a specific account, rather than each time having to select each of these.'
            break

          case 'INK YIELD':
            text = 'This represents the average ink yield per ink cartridge based on printing a franking indicia only.'
            break

          case 'COST PER IMPRESSION':
            text = 'The cost per impression is taken from the ink cost and published ink yield to provide a guide to the cost per each indicia printed. This excludes any logo or return address which can vary ink usage and ultimately the impressions yielded from a ink cartridge.'
            break

          case 'LOGO RETURN ADDRESS CAPACITY':
            text = 'This relates to the number of logos/graphics and return addresses that the machine has the capacity to store.'
            break

          case 'INTERFACE TYPE':
            text = 'The interface is the type of visual display, this can vary significantly between machine and manufacturer. This can be an important consideration as affects the usability, navigation of functionality and ease of use of you chosen franking solution.'
            break

          case 'MAIL FEEDER':
            text = 'Mail feeders fall into three key types for franking solutions. Hand feeding machine allow the operator to pass a single letter through the franking machine for processing, before moving on to the next letter. Automatic mail feeders allow the user to stack same size and weight items of the same class onto the feeder, it will then very quickly frank these items at the pre selected postal rate and tariff. Fully-automatic mail feeders allow the user to stack mixed size and weight items on the feeder, all the user needs to do is choose the class and the machine will automatic measure the length, width, thickness and weight on each item and frank accordingly, this prevents human errors (associated Royal Mail fines) and allows post to be processed very quickly.'
            break

          case 'LABEL DISPENSER':
            text = 'There are three types of label processing available depending on the franking machine model. Postcard style labels are provided with two label strips, one on the top and one on the bottom edge; these are processed in exactly the same way as letters for any oversized items to thick to pass through the letter feeder. Single label strips; these are loaded into a label hopped on compatible machines and allow the user to print labels quickly and easily for oversized items, this is especially useful when a large number of packets and/or parcels are being processed which do not fit through the mail feeder. The third type of label feeder is a label roll dispenser, this technology is only available on Pitney Bowes machines, the label rolls typically provide 722 indicia only prints per roll meaning infrequent requirement for refilling and an excellent solution for any mailroom producing a large number of oversize items. The labels on label rolls are cut to size so to minimise wastage, if printing an indicia only the machine will cut the label to just the size of the indicia, if printing a logo/return address the machine cuts the label longer to allow for this also.'
            break

          case 'WEB BASED REPORTING':
            text = 'Web based postage reporting provides the ability to review postage spend from any web connected PC. This is an excellent tool providing businesses with management information and a detailed understand of how your postage spend is being utilised. The reporting tools provides detail on the volumes and spend by class and allows you to down reports in pdf or excel and as graphs of a detailed table format. The same reporting information is also available on many models* with web based reporting activated to allow department account reports on items and spend processed across your chosen date ranges to support simplified cross charging processes. *check with us to confirm that your desired model allows this if this is an important function for your business*'
            break

          case 'DIMENSIONS':
            text = 'This confirms the manufacturer published dimensions of this model.'
            break

          case 'MAIL MARK COMPLIANT':
            text = 'Royal Mail introduced Mail Mark in XXXX, this moved franking machines to the ability to automatically update postal rates and transitioned machines from the old town circle franking indicia to a 2D barcode to support automation in Royal Mail processes. Mail Mark compliant machines benefit from reduced postal rates in comparison to the legacy town circle franking die options and ultimately provide greater postal savings for businesses.'
            break

          case 'INSTALLATION AND TRAINING':
            text = 'Where applicable installation and training allows for an onsite engineer to support on the setup, installation and training on the use of the new franking solution.'
            break

          case 'SCALE CAPACITY':
            text = 'There is a wide range of scale capacity options available on franking machine models, these range from 2kg-35kg depending on manufacturer and model. The larger the scale capacity the greater the functionality and flexibility of processing varied weight items for your business. However, increasing scale capacities can be a costly approach to manage irregular high weight items so it is worth considering what scale capacity is truly required. All machines have the ability to manually enter the weight of an item too heavy for the scale provided, allowing adhoc items to be weighed separately but still processed through the franking machine.'
            break

          case 'CUSTOM LOGO/RETURN ADDRESS INCLUDED WITH NEW MACHINE':
            text = 'Logo and return addresses are available on all machines, however only some provide these free of charge with the machine. Where a logo or return address isn\'t provided with the machine you have the option to add this at a cost.'
            break

          case 'CONNECTIVITY KIT OPTIONS':
            text = 'All new mailing machines require a network connection for updates, to transmit postage spend information and for postage top ups/refills. Some models offer the option of wifi connection, 3G connection (via a dongle) or PC meter connect (this utilises a PC with internet connection and some software to allow a connection.'
            break

          case 'INBOUND COURIER PARCEL TRACING':
            text = ' This technology is only available from Pitney Bowes and provides the ability to add a barcode scanner to the franking machine. This then allows the users to scan the barcode on items received, input the intended recipient, send an email notification to the recipient confirming an item has been received for them before the team print a delivery manifest on a connected printed (not supplied) and take to the recipient to sign on delivery. Future upgrade options are available to allow delivery and signature capture via WiFi or 3g connected PDAs.'
            break

          case 'OUTBOUND SHIPPING APPLICATION':
            text = 'This technology allows users to rate shop for recorded, special delivery 1pms and parcel/packets for shipping. The kit provides the license, a shipping label printer and 30kg scale for PC connection. A user can then save regular recipients they send to whilst also entering the email of the sender and recipient to provide tracking information automatically on posting.'
            break

          case 'DEPARTMENTAL ACCOUNTING':
            text = 'Departmental accounting allows your business to name accounts and allocate items/spend to the relevant accounts. This then allows future reporting to simplify the process of cross billing.'
            break

          case 'DIFFERENTIAL WEIGHING':
            text = 'The differential weighing feature is a great feature for any business regularly sending a large number of packets/parcels. The operator can stack the items collectively on the scale, choose the appropriate class and under differential mode as an item is removed a label for the item can be printed and applied to that item, this process can then be repeated for all items on the scale speeding up the process of shipping.'
            break

          case 'SERVICE / MAINTENANCE OFFERING':
            text = 'Information being prepared...'
            break

          case 'FIRST STEP':
            text = 'Information being prepared...'
            break

          case 'SECOND STEP':
            text = 'Information being prepared...'
            break

          case 'THIRD STEP':
            text = 'Information being prepared...'
            break

          case 'TARGETED SERVICE LEVEL':
            text = 'Information being prepared...'
            break

          case 'ALL PARTS':
            text = 'Information being prepared...'
            break

          case 'ALL LABOUR':
            text = 'Information being prepared...'
            break

          case 'WEAR & TEAR':
            text = 'Information being prepared...'
            break

          case 'ROYAL MAIL RATE UPDATES':
            text = 'Information being prepared...'
            break

          case 'POSTAGE ACCOUNT TYPE':
            text = false
            break

        }
        return text
      },
      getYoutubeEmbed(url) {
        let youTubeUrl = url
        let youTubeId
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
        let match = youTubeUrl.match(regExp)
        if (match && match[2].length == 11) {
          youTubeId = match[2]
        } else {
          youTubeId = false
        }
        let embed = false
        if (youTubeId) {
          embed = '<iframe width="100%" height="auto" src="//www.youtube.com/embed/' + youTubeId + '" frameborder="0" allowfullscreen></iframe>'
        }
        this.videoEmbed = embed
      },
      getSwitchAndSaveValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.new_costs.switch_and_save.purchase;
        } else {
          value = this.new_costs.switch_and_save.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : 0;
      },
      getEffectiveAnnualSaving(years = -1) {
        let value;
        if (years === -1) {
          value = this.new_costs.annual_savings_available.purchase;
        } else {
          value = this.new_costs.annual_savings_available.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : 0;
      },

      getTotalServiceCost(years = -1) {
        let value;

        if (years === -1) {
          value = this.new_costs.total_service_cost.purchase;
        } else {
          value = this.new_costs.total_service_cost.lease
        }

        if (value) {
          value = value.toFixed(2)
        }

        return value ? value : 0;
      },

      getTotalEffectiveCostValue(years = -1) {
        let value;
        if (years === -1) {
          // Purchase

          // If franking user, pull from C64 (total_cost_future_ownership). Else use C52 (total_equipment_and_service_cost)
          if (this.quote.uses_franking_machine) {
            // Franking machine YES
            if (this.new_costs.annual_savings_available.purchase < 0) { // C54 is NEGATIVE
              value = this.new_costs.total_equipment_and_service_cost.purchase // use C52
            } else {
              value = this.new_costs.total_cost_future_ownership.purchase // use C64
            }
          } else {
            // Franking machine NO
            value = this.new_costs.total_equipment_and_service_cost.purchase
          }

        } else {
          // Lease

          // If franking user, pull from C64 (total_cost_future_ownership). Else use C52 (total_equipment_and_service_cost)
          if (this.quote.uses_franking_machine) {
            // Franking machine YES
            if (this.new_costs.annual_savings_available.lease[years] < 0) { // C54 is NEGATIVE
              value = this.new_costs.total_equipment_and_service_cost.lease[years] // use C52
            } else {
              value = this.new_costs.total_cost_future_ownership.lease[years] // use C64
            }
          } else {
            // Franking machine NO
            value = this.new_costs.total_equipment_and_service_cost.lease[years] // use C52
          }
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : 0;
      },
      getSavingOverTermValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.new_costs.savings_over_term.purchase;
        } else {
          value = this.new_costs.savings_over_term.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : 0;

      },

      getAnnualPostageSavingsValue(years = -1) {
        let value;

        value = this.new_costs.postage_savings;

        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : 0;

      },

      getPostageSavingOverTermValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.new_costs.postage_savings_over_term.purchase;
        } else {
          value = this.new_costs.postage_savings_over_term.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : 0;

      },

      manufacturerImage(manufacturer_id = false) {
        if (!manufacturer_id)
          return 'http://placehold.it/195x195'

        return '/static/styles/mailkit/img/logos/manu' + (manufacturer_id - 1) + '.png'
      },
      makeNumberWithPound(number, tofixed = 2) {
        if (number < 0) {
          return '-&pound;' + _n(Math.abs(number), tofixed)
        }
        return '&pound;' + _n(number, tofixed)
      },
      progressWithOrder(investment_option) {
        if (investment_option === false) investment_option = 0
        this.$emit('progress-with-order', investment_option)
      },
      formatScale(model, additionalOptions) {
        if (!this.additionalOptions.packets_capacity) {
          return model.scale_capacity
        }
        let capacity = this.additionalOptions.packets_capacity.split('_')
        let cap1 = capacity[0]
        let cap2 = capacity[1] || null

        if (model.scale_capacity >= cap1) {
          return model.scale_capacity
        }

        for (let i = 1; i < 5; i++) {
          if (model['scale_option_' + i] >= cap1) {
            return model['scale_option_' + i]
          }
        }

        return model.scale_capacity


      },
      getModelDepAccounting(model) {

        if (model.departmental_accounting >= this.additionalOptions.accounts_amount) {
          return model.departmental_accounting
        }

        for (let i = 1; i < 5; i++) {
          if (model['accounting_option_' + i] >= this.additionalOptions.accounts_amount) {
            return model['accounting_option_' + i]
          }
        }

        return model.departmental_accounting
      }
    }
  }
</script>

<style scoped lang="scss">

  @media(min-width: 768px) {
    .proposed-quote-details-table {
      display: flex
    }
  }

  @media(max-width: 767px) {
    .proposed-quote-details-table {
      display: block !important
    }
    .advert-banner-table {
      display: block !important
    }
    .advert-banner-table .optionsPanel {
      padding: 10vw 2vw;
      border-top: 0 !important;
      border-left: 1px solid #ccc !important;
      border-bottom: 1px solid #ccc !important;
      border-right: 1px solid #ccc !important;
    }
  }

  .manufacturer_image {
    max-width: 100%;
    padding: 0 10px !important;
  }

  .width-250 {
    width: 300px !important;
  }

  .option-btn {
    color: white !important;
    cursor: pointer;
    margin-top: 5px;
    background: #0a70e3 !important;
  }

  .infoContent {
    line-height: 1.8;
  }

  @media screen and (max-width: 1024px) {
    .options__split > div:first-of-type {
      padding-right: 10px;
    }

    .options__split > div:last-of-type {
      margin-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Results/MoreInfo.vue